import React, { Component } from "react";
import { Table } from "antd";
import { req_list_lrs_finishByDepartment } from "../../api";
import storageUtils from "../../utils/storageUtils";

export default class FinishByDepartment extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    items: [],
  };

  UNSAFE_componentWillMount() {
    this.api_list_items();
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    this.setState({ loading: true });
    const result = await req_list_lrs_finishByDepartment(
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "授課老師科系",
        dataIndex: "courseDepartment",
        width: 60,
      },
      {
        title: "開課總數",
        dataIndex: "courseTotal",
        width: 30,
        render: (courseTotal) => <>{courseTotal}門</>,
      },
      {
        title: "已完成教材上傳課程數",
        dataIndex: "doneCourseTotal",
        width: 30,
        render: (doneCourseTotal) => <>{doneCourseTotal}門</>,
      },
      {
        title: "完成率",
        dataIndex: "sumCourseTotal",
        width: 65,
        render: (sumCourseTotal) => <>{sumCourseTotal}%</>,
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { items } = this.state;
    return (
      <>
        <Table
          scroll={{ y: 480 }}
          dataSource={items}
          columns={this.columns}
          pagination={false}
          rowKey="courseDepartment"
        />
      </>
    );
  }
}
